import _ from 'underscore';
import $ from 'jquery';

export default class OrderDocuments {
  constructor($scope, OrderService, UiService, EmailService) {
    $scope.$on('publish_attachments', function(event, data) {
      $scope.attachments = data.attachments;
    });

    $scope.$on('publish_contacts', function(event, data) {
      $scope.contacts = data.contacts;
      _.each($scope.contacts, function(c) {
        c.recipient_mode = 0;
      });
    });

    $scope.send_notification = function() {
      var attachments = _.where($scope.attachments, {
        checked: true
      });
      var contacts = _.where($scope.contacts, {
        checked: true
      });
      if (attachments.length === 0) {
        alert('Please select at least one document!');
        return false;
      }
      if (contacts.length === 0) {
        alert('Please select at least one contact!');
        return false;
      }
      $scope.sending_notification = true;
      OrderService.send_notification(window.order.id, $scope.custom_title, $scope.custom_text, attachments, contacts, $scope.sender_name_en, $scope.sender_name_el, $scope.test_send, $scope.test_send_email).success(function(data) {
        if (data.success) {
          $scope.sending_notification = false;
        }
      });
    };
    


    $scope.edit_custom_text = function() {
      $.fancybox($('div#edit_template'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no',
        afterShow: function() {
          $scope.$broadcast('$tinymce:refresh');
        }
      });
    };

    $scope.save_custom_text = function() {
      $.fancybox.close();
    };

    $scope.init = function() {
      $scope.order_id = window.order.id;
      $scope.use_buyer_contacts = window.use_buyer_contacts;
      $scope.user_id = window.use_buyer_contacts ? window.order.buyer_id : window.order.supplier_id;
      $scope.tinymceOptions = UiService.tinymceOptions();
      $scope.custom_title = '';
      $scope.custom_text = '';
      $scope.test_send = true;
      $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
      $scope.recipient_modes = EmailService.get_recipient_modes();
      $scope.sender_names_en = EmailService.get_sender_names_en();
      $scope.sender_names_el = EmailService.get_sender_names_el();
      $scope.sender_name_en = $scope.sender_names_en[0];
      $scope.sender_name_el = $scope.sender_names_el[0];
    };

    $scope.init();
  }
}

OrderDocuments.$inject = ['$scope', 'OrderService', 'UiService', 'EmailService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-documents.ctrl.js